import Error from '../model/Error';
import axios from 'axios';

export default class IsbjCertificateRepository {

    static remove(federationId) {
        return new Promise((resolve, reject) => {
            axios
                .delete('/federations/' + federationId + '/isbj/config/certificate')
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static update(federationId, file) {
        return new Promise((resolve, reject) => {
            axios
                .put('/federations/' + federationId + '/isbj/config/certificate', file, {
                    headers: {'Content-Type': 'application/octet-stream'}
                })
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        })
    }
}
